import { SORT_DIRECTION } from '@common/constants';
import client from '@common/utils/rest';
import { ORDERS_ACTION_TYPES } from '../const/orders';
import { executeUI } from '@common/utils/ui-bridge';

const URL_PREFIX = 'ambry/orders/data';
const URL = `${URL_PREFIX}/ordersList`;

const setOrders = (payload) => {
  return {
    payload,
    type: ORDERS_ACTION_TYPES.setList,
  };
};

const setOrdersCount = (payload) => {
  return {
    payload,
    type: ORDERS_ACTION_TYPES.setListCount,
  };
};

export const resetOrders = () => {
  return setOrders([]);
};

export const getOrders = ({ filtering, pagination, sorting } = { filtering: {}, pagination: {}, sorting: {} }) => (dispatch, getState) => {
  return client({
		params: {
      vieworgorders: filtering.vieworgorders,
      profileId: filtering.profileId,
			query: filtering.searchKeyword,
			start: pagination.start,
			size: pagination.size,
			sortColIndex: sorting.columnIndex || 1,
			sort: true,
			sortAsc: sorting.direction === SORT_DIRECTION.asc
		},
    path: URL,
    method: 'GET',
  }).then((response) => {
    const shouldReset = pagination.start === 0;
    
    if (shouldReset) {
      dispatch(resetOrders());
    }

    const { list } = getState().orders;

    dispatch(setOrders([...list, ...response.entity.orders]));
    dispatch(setOrdersCount(response.entity.total));
  });
};

export const getOrganizations = () => {
  return client({
    path: `${URL_PREFIX}/organizations`,
    method: 'GET',
  }).then((response) => {
    return Object.keys(response.entity).map((id) => ({ id, name: response.entity[id] }));
  });
};

export const linkOrderAndPatient = ({ newGlobalId, oldGlobalId, orderId, profileId }) => {
  return client({
    params: {
      newGlobalId,
      oldGlobalId,
      orderId,
      profileId
    },
    path: `${URL_PREFIX}/link`,
    method: 'POST',
  });
};

const MODULE_NAME = 'ORDERS';

export const openPedigree = (id) => {
	executeUI(MODULE_NAME, 'openPedigree', id);
};

export const openDatasheet = (id) => {
	executeUI(MODULE_NAME, 'openDatasheet', id);
};

export const openTestResults = (id) => {
	executeUI(MODULE_NAME, 'openTestResults', id);
};

export const getOrganizationsAccessStatus = () => {
  return client({
    path: `${URL_PREFIX}/checkOrgOrders`,
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const sendPedigreeToAmbry = ({ orderId, profileId }) => {
    return client({
        params: {
            orderId,
          profileId
        },
        path: `${URL_PREFIX}/order/sendPedigree`,
        method: 'POST',
    });
};